<template>

	<span>

		<div class="modal" v-if="!singleVideo">

			<div :class="{'modal-wrap':true}">

				<div class="modal-inner">

					<h2 class="modal-title">{{ title }}<span class="close" @click="close">X</span></h2>

					<div class="modal-inner-scroll">

						<div class="video-list">

							<h3 class="videos-title" v-if="videoList.current.length>0">Related Videos</h3>

							<div 
								class="video-item"
								v-for="(video, videoIndex) in videoList.current" 
								:key="'video-current-'+videoIndex" 
								@click="loadVideo ( video.slug )"
							>

								<div class="video-thumb"><img :src="video.thumb" :alt="video.title" /></div>

							</div>

							<h3 class="videos-title other" v-if="videoList.current.length>0">Other Videos</h3>
						
							<div 
								class="video-item"
								v-for="(video, videoIndex) in videoList.other" 
								:key="'video-other-'+videoIndex" 
								@click="loadVideo ( video.slug )"
							>

								<div class="video-thumb"><img :src="video.thumb" :alt="video.title" /></div>

							</div>

						</div>

					</div>

				</div>

			</div>

		</div>

		<VideoPlayer 
			v-if="showVideo"
			:videoId="videoId"
			:type="type"
			:title="theVideoTitle"
			@close="closeVideo"
			:customPlaylist="videoIds"
			:autoPlay="autoplayVideo"
		/>

	</span>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import general from './../utils/general'
import VideoPlayer from './VideoPlayer.vue';
export default {
	name: 'Videos',
	components: {
		VideoPlayer
	},
	props: {
	},
	data() {

		return {
			videoId: null,
			showVideo: false,
			fullClose: false,
			type: 'youtube'
		}

	},

	computed: {

		...mapState('general',['videos','playVideo','videoTitle','singleVideo','autoplayVideo']),

		title () {

			return 'Video Guides';

		},

		theVideoTitle () {

			if ( this.videoTitle ) return this.videoTitle;

			if ( this.videoId ) {

				let v = this.videos.find( vid => vid.videoId === this.videoId );

				if ( v ) return v.title;

			}

			return '';

		},

		videoList () {

			let videos = [], videosThisPage = [], 
				page = this.$route.name;

			this.videos.forEach ( function ( video ) {

				if ( !!video.ignore ) return;

				let thumb = require('../assets/img/video-thumbs/'+video.thumb);

				if ( video.pageNames.includes(page) ) {

					videosThisPage.push( { slug: video.slug, title: video.title, thumb: thumb } );

				}
				else {

					videos.push( { slug: video.slug, title: video.title, thumbId: !!video.thumbId ? video.thumbId : video.videoId, thumb: thumb } );

				}

			}.bind(this));
			
			return { other: videos, current: videosThisPage };

		},

		videoIds () {

			return [];

		}

	},

	methods: {

		...mapMutations('general',['updateVar']),

		closeVideo () {

			this.showVideo = false;
			general.modalClose();
			if ( this.fullClose ) this.close();

		},

		close () {

			this.$emit('close');

		},
		loadVideo ( slug ) {

			let v = this.videos.find( vid => vid.slug === slug );
			
			this.videoId = v.videoId;
			this.type = v.type || 'youtube';
			this.showVideo = true;

		},
		
	},
	mounted() {

		if ( this.playVideo ) {

			this.loadVideo ( this.playVideo );
			this.fullClose = true;

		}

		this.updateVar( { varName: 'playVideo', info: null } );

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
.modal {
	.modal-wrap {
		&.hidden {
			.opacity(0);
		}
	}
}
.video-list {

	.videos-title {

		&.other {

			margin-top: 20px;

		}

	}

	.video-item {

		cursor: pointer;

		.video-title {

			margin-top: 5px;

		}

		.video-thumb {

			position: relative;
			cursor: pointer;
			margin-top: 20px;

			&:last-child {

				margin-top: 0;

			}

			img {

				max-width: 100%;

			}

		}

		&:hover {

			.video-thumb {

				img {

					.opacity(0.8);

				}

				&:after {

					.opacity(1);

				}

			}

		}

	}

}

@media screen and (min-width: 540px) {

	.video-list {

		.video-item {

			display: inline-block;
			margin-top: 20px;
			width: 100%;
			text-align: left;

			.video-thumb {

				display: inline-block;
				margin-right: 2%;
				box-sizing: border-box;
				margin-top: 0;
				vertical-align: middle;

			}

			.video-title {

				display: inline-block;
				width: 60%;
				text-align: left;
				box-sizing: border-box;
				margin-top: 0;
				vertical-align: middle;

			}

		}

	}

}

@media screen and (min-width: 768px) {

	.video-list {

		.video-item {

			width: 31%;
			margin-left: 2%;

			.video-thumb {

				margin-right: 4%;

			}

			.video-title {

				width: 50%;

			}

		}

	}

}

</style>